import type { Common } from '@libs/domain';
import { MstRegistration, MstRegistrationRaw } from '@libs/templates/mst';

class LocationMstRegistration extends MstRegistration implements Pick<Common['schema'], 'address'> {
  private constructor(
    mstRegistration: MstRegistration,
    readonly address: string,
  ) {
    super(
      mstRegistration.id,
      mstRegistration.version,
      mstRegistration.code,
      mstRegistration.name,
      mstRegistration.mstSpareName01,
      mstRegistration.mstSpareName02,
      mstRegistration.validityStartDate,
      mstRegistration.validityEndDate,
      mstRegistration.mstNote,
    );
  }

  static init(code?: string) {
    return new LocationMstRegistration(MstRegistration.baseInit(code), '');
  }

  static fromRaw(raw: LocationMstRegistrationRaw) {
    return new LocationMstRegistration(MstRegistration.baseFromRaw(raw), raw.address);
  }
}

class LocationMstRegistrationRaw extends MstRegistrationRaw implements Pick<Common['record'], 'address'> {
  private constructor(
    mstRegistrationRaw: MstRegistrationRaw,
    readonly address: string,
  ) {
    super(
      mstRegistrationRaw.id,
      mstRegistrationRaw.version,
      mstRegistrationRaw.code,
      mstRegistrationRaw.name,
      mstRegistrationRaw.mstSpareName01,
      mstRegistrationRaw.mstSpareName02,
      mstRegistrationRaw.validityStartDate,
      mstRegistrationRaw.validityEndDate,
      mstRegistrationRaw.mstNote,
    );
  }

  static fromModel(locationMstRegistration: LocationMstRegistration) {
    return new LocationMstRegistrationRaw(
      MstRegistrationRaw.baseFromModel(locationMstRegistration),
      locationMstRegistration.address,
    );
  }
}

export { LocationMstRegistration, LocationMstRegistrationRaw };
